<template>
  <div>
    <carousel
      class="home-banner"
      :autoplay="true"
      :items="1"
      :nav="false"
      :animateOut="'fadeOut'"
    >
      <section class="home-banner__item">
        <img
          src="@/assets/banners/banner02-1.jpg"
          alt
          class="home-banner__item--desktop"
        />
        <img
          src="@/assets/banners/banner02-1.jpg"
          alt
          class="home-banner__item--mobile"
        />
        <div class="home-banner__item__text">
          <div class="limit-grid">
            <h1>Tour no Morumbi</h1>
            <p>
              Filia-se ao Cartão de TODOS São Paulo FC e ganhe 10% no Morumbi
              Tour
            </p>
          </div>
        </div>
      </section>
      <section class="home-banner__item">
        <img
          src="@/assets/banners/banner-1.jpg"
          alt
          class="home-banner__item--desktop"
        />
        <img
          src="@/assets/banners/banner-1.jpg"
          alt
          class="home-banner__item--mobile"
        />
        <div class="home-banner__item__text">
          <div class="limit-grid">
            <h1>Campeão na saúde</h1>
            <p>
              Consultas com clínico geral por R$ {{ cdtPrices.clinico_geral }} e
              demais especialidades, R$ {{ cdtPrices.demais }}. Tudo por apenas
              R$ {{ cdtPrices.valor }} mensais para toda a família.
            </p>
          </div>
        </div>
      </section>
    </carousel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import carousel from "vue-owl-carousel";
export default {
  data() {
    return {
      banners: null,
    };
  },
  components: { carousel },
  methods: {
    getBanners() {
      this.$api
        .get(`pages/7`)
        .then((response) => {
          this.banners = response.data.acf.banner;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getBanners();
  },
  computed: {
    ...mapGetters(["cdtPrices"]),
  },
};
</script>

<style lang="scss">
.home-banner {
  position: relative;
  .owl-dots {
    position: absolute;
    bottom: 78px;
    left: 50%;
    transform: translateX(-50%);
    @include media(">=tablet") {
      bottom: 98px;
    }
    @keyframes sizeBar {
      0% {
        width: 0%;
      }
      100% {
        width: 100%;
      }
    }
    .owl-dot {
      outline: none;
      span {
        width: 54px !important;
        height: 5px !important;
        border-radius: initial !important;
        background: RGBA(255, 255, 255, 0.5);
        position: relative;
        &::after {
          content: "";
          width: 0%;
          height: 100%;
          background: $color-primary;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      &.active {
        span {
          &::after {
            animation: sizeBar 5s forwards;
          }
        }
      }
    }
  }
  &__item {
    height: 403px;
    @include media(">=tablet") {
      height: 518px;
    }
    &--desktop {
      display: none !important;
      @include media(">=tablet") {
        display: block !important;
      }
    }

    &--mobile {
      display: block !important;
      @include media(">=tablet") {
        display: none !important;
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 80%;
      @include media(">=tablet") {
        object-position: initial;
      }
    }
    &__text {
      position: absolute;
      top: 20%;
      left: 0;
      width: 100%;
      @include media(">=tablet") {
        top: 50%;
        transform: translateY(-50%);
      }

      h1 {
        font-size: 40px;
        line-height: 49px;
        font-family: "Arvo", sans-serif;
        font-weight: bold;
        color: $color-primary;
        margin-bottom: 11px;
        @include media("<=small") {
          font-size: 22px;
          line-height: 27px;
          text-align: center;
        }
      }

      p {
        max-width: 492px;
        font-weight: 700;
        font-size: 24px;
        line-height: 30px;
        color: $color-white;
        margin: 0px auto 0px 0px;

        @include media("<=small") {
          margin: 0px auto;
          font-size: 14px;
          text-align: center;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
